import { EmptyState404 } from '../Common/EmptyStates';

function NotFoundPage() {
  return (
    <section className="section-main section-full not-found-page">
      <div className="container">
        <EmptyState404 />
      </div>
    </section>
  );
}

export default NotFoundPage;
